import {useSingleColumn} from '@/utils/hooks';
import BenefitCard from './BenefitCard';
import {
  CARD_WIDTH,
  WIDGET_CARD_RADIUS,
  WIDGET_TITLE_SIZE,
  WIDGET_TITLE_WEIGHT
} from '@/utils/constants';

const GAP = 24;
const PADDING = 24;

const BenefitCardsGrid = ({
  benefits,
  onClick,
  titleWeight,
  color,
  radius,
  titleSize
}: {
  benefits?: any[];
  onClick: (id: number) => () => void;
  titleSize: WIDGET_TITLE_SIZE;
  titleWeight: WIDGET_TITLE_WEIGHT;
  radius: WIDGET_CARD_RADIUS;
  color: string;
}) => {
  const {ref, isSingleColumn} = useSingleColumn(CARD_WIDTH, GAP, PADDING);
  return (
    <div
      className="flex w-full flex-row flex-wrap"
      style={{gap: `${GAP}px`, paddingLeft: `${PADDING}px`}}
      ref={ref}
    >
      {(benefits || []).map((card, index) => (
        <div
          key={`grid-card-${index}`}
          style={{
            ...(!isSingleColumn && {width: `${CARD_WIDTH}px`})
          }}
        >
          <BenefitCard
            image={card.image as string}
            title={card.name as string}
            titleSize={titleSize}
            titleWeight={titleWeight}
            radius={radius}
            color={color}
            isSingleColumn={isSingleColumn}
            onClick={onClick(card.id)}
          />
        </div>
      ))}
    </div>
  );
};

export default BenefitCardsGrid;
